var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaverseTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_53079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.81812 20.4101C6.28987 24.3114 9.34912 27.3654 11.6136 30.8665C22.7789 48.1289 -4.19613 51.998 26.8406 62.139C35.9102 65.1025 65.3992 67.4371 58.3377 44.9895C55.1691 34.9166 41.205 33.2289 36.4075 24.1391C33.8191 19.235 34.4551 12.927 31.2289 8.4169C28.4045 4.46865 23.9087 0.284271 18.9332 0.0163961C9.34712 -0.499604 1.36962 11.2691 4.81812 20.4101Z",
    fill: "url(#paint0_linear_1543_53079)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3171 24.0703C49.073 23.9911 48.8223 24.1736 48.8223 24.4302V32.0621C48.8223 32.1996 48.8975 32.3256 49.0175 32.3925C50.6261 33.2883 52.0483 34.3102 53.2565 35.4162C52.2548 35.9135 51.1059 36.3826 49.8253 36.8181C49.5193 36.9222 49.3131 37.2101 49.3131 37.5335V52.4168C49.3131 52.8856 49.8106 53.1871 50.2271 52.9717C54.9618 50.5237 57.8043 47.5853 57.8043 45.2495V44.2596V30.529C57.8043 28.0475 54.5951 25.7843 49.3171 24.0703Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1922 52.9718C13.6087 53.1872 14.1062 52.8857 14.1062 52.417V37.5335C14.1062 37.2102 13.9001 36.9222 13.5941 36.8181C12.3135 36.3826 11.1646 35.9135 10.1629 35.4162C11.3711 34.3101 12.7932 33.2883 14.4019 32.3925C14.522 32.3256 14.5971 32.1996 14.5971 32.0621V24.4302C14.5971 24.1736 14.3464 23.9911 14.1022 24.0703C8.82436 25.7843 5.61523 28.0475 5.61523 30.529V44.2596V45.2495C5.61498 47.5853 8.45761 50.5237 13.1922 52.9718Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.957 13.3971H48.4657C48.8109 13.3971 49.0907 13.1173 49.0907 12.7721C49.0907 12.4268 48.8109 12.1471 48.4657 12.1471H46.957C46.6118 12.1471 46.332 12.4268 46.332 12.7721C46.332 13.1173 46.6119 13.3971 46.957 13.3971Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.957 15.5111H51.9658C52.311 15.5111 52.5908 15.2314 52.5908 14.8861C52.5908 14.5409 52.311 14.2611 51.9658 14.2611H46.957C46.6118 14.2611 46.332 14.5409 46.332 14.8861C46.332 15.2314 46.6119 15.5111 46.957 15.5111Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.957 17.6252H51.9658C52.311 17.6252 52.5908 17.3455 52.5908 17.0002C52.5908 16.655 52.311 16.3752 51.9658 16.3752H46.957C46.6118 16.3752 46.332 16.655 46.332 17.0002C46.332 17.3455 46.6119 17.6252 46.957 17.6252Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86523 54.522H8.37398C8.71923 54.522 8.99898 54.2422 8.99898 53.897C8.99898 53.5517 8.71923 53.272 8.37398 53.272H6.86523C6.51998 53.272 6.24023 53.5517 6.24023 53.897C6.24023 54.2422 6.52011 54.522 6.86523 54.522Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.874 55.3861H6.86523C6.51998 55.3861 6.24023 55.6659 6.24023 56.0111C6.24023 56.3564 6.51998 56.6361 6.86523 56.6361H11.874C12.2192 56.6361 12.499 56.3564 12.499 56.0111C12.499 55.6659 12.2191 55.3861 11.874 55.3861Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.874 57.5001H6.86523C6.51998 57.5001 6.24023 57.7799 6.24023 58.1251C6.24023 58.4704 6.51998 58.7501 6.86523 58.7501H11.874C12.2192 58.7501 12.499 58.4704 12.499 58.1251C12.499 57.7799 12.2191 57.5001 11.874 57.5001Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.967 19.1726H45.167C45.0012 19.1726 44.8422 19.2383 44.7251 19.3557L41.8845 22.1963C40.9947 22.0426 40.0787 21.9005 39.138 21.7708C38.9111 21.7396 38.7087 21.9166 38.7087 22.1457V25.6938C36.9455 25.0545 34.2634 24.078 34.1646 24.0168C33.8034 23.7943 33.6021 23.4118 33.6021 23.0143V22.2997C35.3031 22.1315 36.6187 21.182 36.6815 18.981C37.0816 18.9746 37.4041 18.6487 37.4041 18.2471V13.8735C37.5827 13.7717 37.7415 13.6255 37.8709 13.4233C38.7046 12.1205 37.0605 8.31046 32.0709 8.22959C28.2154 8.16709 26.2595 9.73484 26.3144 11.6173L26.3137 11.6232C26.1409 11.8086 24.8657 13.2906 25.568 15.9046C25.4257 16.1543 25.3436 16.4427 25.3436 16.7507C25.3436 17.6983 26.1117 18.4665 27.0594 18.4665C27.1306 18.4665 27.2006 18.4608 27.2696 18.4523C27.3327 18.6698 27.4936 18.8455 27.7016 18.929C27.983 19.9378 28.5799 20.9707 29.8189 21.6192V23.0145C29.8189 23.412 29.6176 23.7945 29.2564 24.017C29.1576 24.0781 26.4756 25.0546 24.7122 25.694V22.1458C24.7122 21.9168 24.5099 21.7397 24.283 21.771C21.8102 22.1117 19.505 22.538 17.4125 23.0375C17.2425 23.0781 17.1232 23.2305 17.1232 23.4052V30.3571C17.1232 30.6216 17.3874 30.804 17.6346 30.7102C19.1722 30.1278 20.8226 29.6513 22.5674 29.3032L20.622 38.8063C19.7904 38.6592 18.9819 38.5021 18.2001 38.3348C17.7299 38.2343 17.2872 38.5935 17.2872 39.0743V54.5947C17.2872 54.9211 17.4962 55.2103 17.8061 55.3131C18.6009 55.5768 19.4244 55.8243 20.2726 56.0542L15.6792 60.6476H6.86523C6.51998 60.6476 6.24023 60.9273 6.24023 61.2726C6.24023 61.6178 6.51998 61.8976 6.86523 61.8976H15.9377C16.1035 61.8976 16.2625 61.8318 16.3796 61.7145L21.6806 56.4135C24.01 56.9702 26.5114 57.3883 29.1432 57.6176C29.5846 57.656 29.9644 57.3067 29.9644 56.8637V46.6596H33.4561V56.8637C33.4561 57.3068 33.8359 57.6561 34.2772 57.6176C35.6936 57.4942 37.0712 57.3151 38.4057 57.0903V57.9267C38.4057 58.2718 38.6856 58.5517 39.0307 58.5517H46.744C47.0891 58.5517 47.369 58.2718 47.369 57.9267V53.1968C47.369 52.8517 47.0891 52.5718 46.744 52.5718H46.1334V39.0743C46.1334 38.5935 45.6907 38.2343 45.2205 38.3348C44.4389 38.5021 43.6304 38.6592 42.7986 38.8063L40.8532 29.3032C42.5981 29.6515 44.2484 30.1278 45.786 30.7102C46.0334 30.8038 46.2974 30.6215 46.2974 30.3571V23.4051C46.2974 23.2303 46.1781 23.078 46.0081 23.0373C45.1652 22.8362 44.2862 22.6475 43.3772 22.4708L45.4255 20.4227H51.9666C52.3119 20.4227 52.5916 20.143 52.5916 19.7977C52.5916 19.4525 52.3121 19.1726 51.967 19.1726Z",
    fill: "#1BCEB9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.1381 18.7708C41.6109 19.1116 43.9161 19.5378 46.0086 20.0373C46.1786 20.0779 46.2979 20.2303 46.2979 20.4051V27.3569C46.2979 27.6214 46.0337 27.8038 45.7865 27.7101C43.7241 26.9289 41.4596 26.3378 39.0352 25.9919C38.8485 25.9653 38.709 25.8066 38.709 25.6178V19.1456C38.7089 18.9166 38.9112 18.7394 39.1381 18.7708Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1381 18.7708C41.6109 19.1116 43.9161 19.5378 46.0086 20.0373C46.1786 20.0779 46.2979 20.2303 46.2979 20.4051V27.3569C46.2979 27.6214 46.0337 27.8038 45.7865 27.7101C43.7241 26.9289 41.4596 26.3378 39.0352 25.9919C38.8485 25.9653 38.709 25.8066 38.709 25.6178V19.1456C38.7089 18.9166 38.9112 18.7394 39.1381 18.7708Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2828 18.7708C21.81 19.1116 19.5048 19.5378 17.4123 20.0373C17.2423 20.0779 17.123 20.2303 17.123 20.4051V27.3569C17.123 27.6214 17.3872 27.8038 17.6344 27.7101C19.6968 26.9289 21.9613 26.3378 24.3857 25.9919C24.5724 25.9653 24.7119 25.8066 24.7119 25.6178V19.1456C24.712 18.9166 24.5097 18.7394 24.2828 18.7708Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2828 18.7708C21.81 19.1116 19.5048 19.5378 17.4123 20.0373C17.2423 20.0779 17.123 20.2303 17.123 20.4051V27.3569C17.123 27.6214 17.3872 27.8038 17.6344 27.7101C19.6968 26.9289 21.9613 26.3378 24.3857 25.9919C24.5724 25.9653 24.7119 25.8066 24.7119 25.6178V19.1456C24.712 18.9166 24.5097 18.7394 24.2828 18.7708Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4373 24.2729C40.3064 23.6336 39.8534 23.1086 39.2396 22.8863C37.5501 22.2746 34.2733 21.0843 34.1639 21.0167C33.8026 20.7942 33.6014 20.4117 33.6014 20.0142V16.2729H29.8178V20.0142C29.8178 20.4117 29.6165 20.7942 29.2553 21.0167C29.1459 21.0843 25.8691 22.2746 24.1795 22.8863C23.5659 23.1086 23.1129 23.6336 22.9819 24.2729L19.8906 39.3734L25.4289 43.6594H37.99L43.5283 39.3734L40.4373 24.2729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9141 24.3467C32.9141 24.3467 33.2616 23.4932 34.2364 23.4932",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.506 24.3467C30.506 24.3467 30.1585 23.4932 29.1836 23.4932",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8187 28.72L24.5703 36.4218",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5996 28.72L38.848 36.4218",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0636 32.2177L40.4373 24.2729C40.3064 23.6336 39.8534 23.1086 39.2396 22.8863C37.5501 22.2746 34.2733 21.0843 34.1639 21.0167C33.8026 20.7942 33.6014 20.4117 33.6014 20.0142V16.2729H29.8178V20.0142C29.8178 20.4117 29.6165 20.7942 29.2553 21.0167C29.1459 21.0843 25.8691 22.2744 24.1795 22.8863C23.5659 23.1086 23.1129 23.6336 22.9819 24.2729L19.8906 39.3734L25.4289 43.6594H37.99",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.709 38.3734V38.1234",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8061 27.529V41.2597C57.8061 36.9097 54.4753 32.4311 49.0195 29.3925C48.8993 29.3256 48.8242 29.1996 48.8242 29.0621V21.4302C48.8242 21.1736 49.075 20.9911 49.3191 21.0703C54.597 22.7843 57.8061 25.0475 57.8061 27.529Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8061 27.529V41.2597C57.8061 36.9097 54.4753 32.4311 49.0195 29.3925C48.8993 29.3256 48.8242 29.1996 48.8242 29.0621V21.4302C48.8242 21.1736 49.075 20.9911 49.3191 21.0703C54.597 22.7843 57.8061 25.0475 57.8061 27.529Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1534 36.8831C38.1987 36.5674 41.9394 36.0367 45.2215 35.3347C45.6918 35.2341 46.1344 35.5934 46.1344 36.0742V51.5946C46.1344 51.921 45.9253 52.2102 45.6155 52.313C42.2733 53.4221 38.438 54.2552 34.2782 54.6175C33.8368 54.6559 33.457 54.3066 33.457 53.8636V37.6366C33.457 37.2424 33.7603 36.9137 34.1534 36.8831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8056 27.5289V42.2494C57.8056 44.5853 54.963 47.5237 50.2285 49.9717C49.812 50.1871 49.3145 49.8856 49.3145 49.4168V34.5334C49.3145 34.2102 49.5206 33.9222 49.8266 33.8181C54.8017 32.1262 57.8056 29.9302 57.8056 27.5289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1534 36.8831C38.1987 36.5674 41.9394 36.0367 45.2215 35.3347C45.6918 35.2341 46.1344 35.5934 46.1344 36.0742V51.5946C46.1344 51.921 45.9253 52.2102 45.6155 52.313C42.2733 53.4221 38.438 54.2552 34.2782 54.6175C33.8368 54.6559 33.457 54.3066 33.457 53.8636V37.6366C33.457 37.2424 33.7603 36.9137 34.1534 36.8831Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8056 27.5289V42.2494C57.8056 44.5853 54.963 47.5237 50.2285 49.9717C49.812 50.1871 49.3145 49.8856 49.3145 49.4168V34.5334C49.3145 34.2102 49.5206 33.9222 49.8266 33.8181C54.8017 32.1262 57.8056 29.9302 57.8056 27.5289Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4939 38.0145C52.3622 38.0302 52.2302 38.0453 52.0977 38.0599",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4939 36.05C52.3622 36.0657 52.2302 36.0808 52.0977 36.0954",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.373 45.7596V40.7411",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7578 43.2958V34.8175",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61523 27.529V41.2597C5.61523 36.9097 8.94598 32.4311 14.4019 29.3925C14.522 29.3256 14.5971 29.1996 14.5971 29.0621V21.4302C14.5971 21.1736 14.3464 20.9911 14.1022 21.0703C8.82436 22.7843 5.61523 25.0475 5.61523 27.529Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61523 27.529V41.2597C5.61523 36.9097 8.94598 32.4311 14.4019 29.3925C14.522 29.3256 14.5971 29.1996 14.5971 29.0621V21.4302C14.5971 21.1736 14.3464 20.9911 14.1022 21.0703C8.82436 22.7843 5.61523 25.0475 5.61523 27.529Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2681 36.8831C25.2229 36.5674 21.4821 36.0367 18.2 35.3347C17.7297 35.2341 17.2871 35.5934 17.2871 36.0742V51.5946C17.2871 51.921 17.4962 52.2102 17.806 52.313C21.1482 53.4221 24.9835 54.2552 29.1434 54.6175C29.5849 54.6559 29.9645 54.3066 29.9645 53.8636V37.6366C29.9645 37.2424 29.6612 36.9137 29.2681 36.8831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61523 27.5289V42.2494C5.61523 44.5853 8.45786 47.5237 13.1924 49.9717C13.6087 50.1871 14.1064 49.8856 14.1064 49.4168V34.5334C14.1064 34.2102 13.9002 33.9222 13.5942 33.8181C8.61911 32.1262 5.61523 29.9302 5.61523 27.5289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2681 36.8831C25.2229 36.5674 21.4821 36.0367 18.2 35.3347C17.7297 35.2341 17.2871 35.5934 17.2871 36.0742V51.5946C17.2871 51.921 17.4962 52.2102 17.806 52.313C21.1482 53.4221 24.9835 54.2552 29.1434 54.6175C29.5849 54.6559 29.9645 54.3066 29.9645 53.8636V37.6366C29.9645 37.2424 29.6612 36.9137 29.2681 36.8831Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42161 47.6298C10.4856 48.4353 11.7506 49.2263 13.1924 49.9717C13.6089 50.1871 14.1064 49.8856 14.1064 49.4168V34.5334C14.1064 34.2102 13.9002 33.9222 13.5942 33.8181C8.61911 32.1262 5.61523 29.9301 5.61523 27.5289V42.2494C5.61523 43.1523 6.04161 44.1454 6.83611 45.1652",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9277 38.0145C11.0595 38.0302 11.1915 38.0453 11.324 38.0599",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9277 36.05C11.0595 36.0657 11.1915 36.0808 11.324 36.0954",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0488 45.7596V40.7411",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66406 43.2958V34.8175",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2033 13.0298V8.61704L26.3333 8.60266C26.3333 8.60266 24.7684 10.1485 25.6019 13.0298H29.2033Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2033 13.0298V8.61704L26.3333 8.60266C26.3333 8.60266 24.7684 10.1485 25.6019 13.0298H29.2033Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4625 9.44995V12.0827C27.3332 12.0516 27.1984 12.0346 27.0595 12.0346C26.1119 12.0346 25.3438 12.8027 25.3438 13.7503C25.3438 14.698 26.1119 15.4661 27.0595 15.4661C27.2402 15.4661 27.4144 15.438 27.578 15.3861C27.837 16.8228 28.6396 18.4671 30.9934 19.0583C33.8029 19.7641 36.6862 19.2192 36.6862 15.8167C36.6862 12.1926 36.6862 9.44983 36.6862 9.44983L27.4625 9.44995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4625 9.44995V12.0827C27.3332 12.0516 27.1984 12.0346 27.0595 12.0346C26.1119 12.0346 25.3438 12.8027 25.3438 13.7503C25.3438 14.698 26.1119 15.4661 27.0595 15.4661C27.2402 15.4661 27.4144 15.438 27.578 15.3861C27.837 16.8228 28.6396 18.4671 30.9934 19.0583C33.8029 19.7641 36.6862 19.2192 36.6862 15.8167C36.6862 12.1926 36.6862 9.44983 36.6862 9.44983L27.4625 9.44995Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8045 10.3569V15.2472C35.8045 15.6527 35.4761 15.9817 35.07 15.9817H27.9747C27.5694 15.9817 27.2402 15.6527 27.2402 15.2472V10.3569C27.2402 9.95144 27.5692 9.62244 27.9747 9.62244H35.07C35.4762 9.62244 35.8045 9.95144 35.8045 10.3569Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6693 15.9814H29.9767C29.5711 15.9814 29.2422 15.6526 29.2422 15.2469V10.3568C29.2422 9.95119 29.5711 9.62231 29.9767 9.62231H36.6693C37.0749 9.62231 37.4038 9.95119 37.4038 10.3568V15.2469C37.4038 15.6526 37.0749 15.9814 36.6693 15.9814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6701 9.62231H27.9747C27.5691 9.62231 27.2402 9.95119 27.2402 10.3568V15.2469C27.2402 15.6526 27.5691 15.9814 27.9747 15.9814H36.6701C37.0757 15.9814 37.4046 15.6526 37.4046 15.2469V10.3568C37.4046 9.95119 37.0757 9.62231 36.6701 9.62231Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3265 8.81258C26.3873 9.41121 26.6593 10.265 28.0512 10.4911C29.4431 10.7172 29.7176 9.69871 29.7176 9.69871C29.7176 9.69871 30.3977 10.8381 31.9195 11.0453C33.4412 11.2526 34.1288 10.6188 33.8526 10.0493C33.8526 10.0493 36.8211 12.0632 37.8706 10.423C38.7043 9.12008 37.0602 5.31008 32.0705 5.22921C28.0823 5.16483 26.1262 6.84458 26.3265 8.81258Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3265 8.81258C26.3873 9.41121 26.6593 10.265 28.0512 10.4911C29.4431 10.7172 29.7176 9.69871 29.7176 9.69871C29.7176 9.69871 30.3977 10.8381 31.9195 11.0453C33.4412 11.2526 34.1288 10.6188 33.8526 10.0493C33.8526 10.0493 36.8211 12.0632 37.8706 10.423C38.7043 9.12008 37.0602 5.31008 32.0705 5.22921C28.0823 5.16483 26.1262 6.84458 26.3265 8.81258Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6459 29.7815C30.6459 30.4709 30.087 31.0299 29.3975 31.0299H27.6973",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7754 29.7815C32.7754 30.4709 33.3343 31.0299 34.0238 31.0299H35.724",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.959 9.77197H48.4676",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.959 11.8861H51.9676",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.959 14.0002H51.9676",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6367 19.3284L45.1673 16.7976H51.9673",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9715 53.2389L15.9377 58.2726H6.86523",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86523 50.897H8.37398",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86523 53.0111H11.874",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86523 55.1251H11.874",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9131 46.6473C26.4595 46.1547 27.6521 44.7935 27.8469 43.0765C28.1113 40.7451 26.4356 38.641 24.1044 38.3765C21.7731 38.112 19.6689 39.7877 19.4044 42.119C19.2455 43.5201 19.7874 44.8393 20.7511 45.7262L24.9131 46.6473Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9136 46.6471C24.36 46.8238 23.7617 46.8885 23.1472 46.8188C22.2177 46.7134 21.3915 46.3152 20.752 45.7262C21.3401 45.4492 21.805 45.3462 22.083 45.3076L22.1965 44.3073L23.4451 44.4489L23.3302 45.462C23.5526 45.5745 24.0193 45.8326 24.6115 46.3871C24.622 46.3976 24.7491 46.5061 24.9136 46.6471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 40.4067C22.1426 40.4067 20.7756 40.4404 20.8808 42.185C20.9654 43.5905 22.4605 43.0675 22.4605 43.0675L22.1426 40.4067Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0955 41.6945C25.0955 41.6945 24.9793 42.7193 24.8258 44.0727C24.6815 45.3441 23.5813 45.4255 22.5618 45.0422C21.7079 44.7222 21.477 44.0735 21.4417 43.5265C21.3778 43.5388 21.3117 43.5417 21.2442 43.534C20.8904 43.4938 20.6359 43.1742 20.676 42.8205C20.7162 42.4667 21.0358 42.2122 21.3895 42.2523C21.4348 42.2573 21.4775 42.2671 21.5205 42.2808C21.6854 42.3355 21.819 42.4541 21.8942 42.6053C21.92 42.6562 21.9689 42.6925 22.0255 42.699C22.1175 42.7093 22.1993 42.6443 22.2095 42.554C22.21 42.5497 22.2105 42.5447 22.2103 42.5395L22.2453 41.3711L25.0955 41.6945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6107 41.9987C21.8801 41.7883 21.5136 40.9415 21.9006 40.287C22.0158 40.0921 22.1904 39.9265 22.4512 39.8311C23.0352 39.6175 23.7594 39.8114 24.3483 39.8474C24.7344 39.8711 25.0656 39.8075 25.2192 39.7706C25.3197 39.7463 25.4221 39.8126 25.4351 39.9152C25.4474 40.0125 25.4093 40.161 25.2386 40.3827C25.2386 40.3827 25.4266 40.4041 25.8248 40.2905C25.9229 40.2625 26.0254 40.3235 26.0467 40.4232C26.0823 40.5907 26.0534 40.8641 25.6898 41.1876L25.9573 41.1593C26.0564 41.1488 26.1449 41.2222 26.1521 41.3216C26.1739 41.6263 26.0767 42.2237 25.0159 42.3471C24.3114 42.429 23.3178 42.2023 22.6107 41.9987Z",
    fill: "#1BCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.832 47.6122C22.087 48.2472 24.5295 48.7522 27.1158 49.0797",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.832 50.061C22.087 50.696 24.5295 51.201 27.1158 51.5285",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7445 55.5515H39.0312C38.6861 55.5515 38.4062 55.2717 38.4062 54.9265V50.1967C38.4062 49.8515 38.6861 49.5717 39.0312 49.5717H46.7445C47.0896 49.5717 47.3695 49.8515 47.3695 50.1967V54.9265C47.3695 55.2718 47.0897 55.5515 46.7445 55.5515Z",
    fill: "#9BE6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.37 50.1973L43.2253 52.8465C43.02 52.9776 42.7574 52.9776 42.5521 52.8465L38.4062 50.1973C38.4062 49.851 38.6863 49.5723 39.0312 49.5723H46.745C47.09 49.5723 47.37 49.851 47.37 50.1973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7445 55.5515H39.0312C38.6861 55.5515 38.4062 55.2717 38.4062 54.9265V50.1967C38.4062 49.8515 38.6861 49.5717 39.0312 49.5717H46.7445C47.0896 49.5717 47.3695 49.8515 47.3695 50.1967V54.9265C47.3695 55.2718 47.0897 55.5515 46.7445 55.5515Z",
    stroke: "#1BCEB9",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3359 39.6363C38.8884 39.3813 41.2997 39.0388 43.5284 38.6213",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3359 42.2C38.8884 41.9463 41.2997 41.6038 43.5284 41.1863",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3359 44.7651C38.8884 44.5101 41.2997 44.1689 43.5284 43.7501",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2461 46.7068C42.0261 46.5851 42.7873 46.4543 43.5283 46.3151",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1855 24.3323V24.3466",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1855 26.2703V26.2846",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1855 28.2083V28.2226",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2344 24.3323V24.3466",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2344 26.2703V26.2846",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2344 28.2083V28.2226",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8848 13.6548V12.4048C13.8848 12.0597 14.1646 11.7798 14.5098 11.7798H15.7598C16.1049 11.7798 16.3848 12.0597 16.3848 12.4048V13.6548C16.3848 13.9999 16.1049 14.2798 15.7598 14.2798H14.5098C14.1645 14.2798 13.8848 14 13.8848 13.6548Z",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95312 18.4156V17.1656C8.95312 16.8205 9.233 16.5406 9.57812 16.5406H10.8281C11.1732 16.5406 11.4531 16.8205 11.4531 17.1656V18.4156C11.4531 18.7608 11.1732 19.0406 10.8281 19.0406H9.57812C9.23287 19.0406 8.95312 18.7608 8.95312 18.4156Z",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9766 20.4628L57.7876 20.2738M57.7876 20.2738C57.2016 19.6878 57.2016 18.7378 57.7876 18.1518M57.7876 20.2738C57.2016 19.6878 56.2516 19.6878 55.6656 20.2738M57.7876 18.1518L57.9766 17.9628M57.7876 18.1518C57.2016 18.7378 56.2516 18.7378 55.6656 18.1518M55.6656 18.1518L55.4766 17.9628M55.6656 18.1518C56.2516 18.7378 56.2516 19.6878 55.6656 20.2738M55.6656 20.2738L55.4766 20.4628",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6094 60.9241L36.4204 60.7351M36.4204 60.7351C35.8344 60.1491 35.8344 59.1991 36.4204 58.6131M36.4204 60.7351C35.8344 60.1491 34.8844 60.1491 34.2984 60.7351M36.4204 58.6131L36.6094 58.4241M36.4204 58.6131C35.8344 59.1991 34.8844 59.1991 34.2984 58.6131M34.2984 58.6131L34.1094 58.4241M34.2984 58.6131C34.8844 59.1991 34.8844 60.1491 34.2984 60.7351M34.2984 60.7351L34.1094 60.9241",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9941 6.30505L22.8051 6.11605M22.8051 6.11605C22.2191 5.53005 22.2191 4.58005 22.8051 3.99405M22.8051 6.11605C22.2191 5.53005 21.2691 5.53005 20.6831 6.11605M22.8051 3.99405L22.9941 3.80505M22.8051 3.99405C22.2191 4.58005 21.2691 4.58005 20.6831 3.99405M20.6831 3.99405L20.4941 3.80505M20.6831 3.99405C21.2691 4.58005 21.2691 5.53005 20.6831 6.11605M20.6831 6.11605L20.4941 6.30505",
    stroke: "#9BE6DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_53079",
    x1: 10.9384,
    y1: 53.4033,
    x2: 43.8488,
    y2: 20.4929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8FFFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5FFF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_53079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverseTestIcon);
export default __webpack_public_path__ + "static/media/metaverse-test-icon.222272f444e35a33118c562b58c01222.svg";
export { ForwardRef as ReactComponent };